/*
 * The base skeleton shape and its shimmer wave, colored from the theme
 * scope's CSS variables so any color a theme supplies works.
 *
 * The wave is an eased bell rather than a two-stop triangle: a hard peak
 * reads as a stripe (Mach banding), and on low-contrast dark ramps a linear
 * ramp quantizes into visible bands. Each stop is the secondary token at a
 * different alpha, so the wave can be lighter or darker than the fill. The
 * bell's width comes from the engine as a CSS variable, so the engine and
 * the stylesheet share one definition.
 */

.shape {
    background-color: var(--colorSkeletonPrimary);
    flex-shrink: 0;
}

/* Text bars in the design fade from the fill to about a fifth of it at the right end. */
.fade {
    mask-image: linear-gradient(to right, #000, rgb(0 0 0 / 20%));
}

.shimmer {
    background-image: linear-gradient(
        90deg,
        transparent 0%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 12%, transparent) 18%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 40%, transparent) 32%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 78%, transparent) 43%,
        var(--colorSkeletonSecondary) 50%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 78%, transparent) 57%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 40%, transparent) 68%,
        color-mix(in srgb, var(--colorSkeletonSecondary) 12%, transparent) 82%,
        transparent 100%
    );
    background-size: var(--psi-shimmer-bell-width) 100%;
    background-repeat: no-repeat;
}
